<template>
  <div class="mb-8 flex flex-col md:flex-row justify-between md:items-center bg-white">
    <div class="flex flex-col">
      <div class="flex items-center leading-none">
        <span class="mr-2 text-xl" v-text="event.title"></span>
        <span>
          <event-status-badge v-if="event" class="text-sm px-2 uppercase" :status="event.status"></event-status-badge>
        </span>
      </div>
      <div class="mt-1 flex flex-col sm:mt-0 sm:flex-row sm:flex-wrap">
        <div class="mt-2 flex items-center text-sm leading-5 text-gray-600 sm:mr-6">
          <font-awesome-icon
            class="text-gray-500 mr-2 flex-shrink-0"
            :icon="['far', 'calendar-star']"
          />
          {{event.start_date.local | date}} Uhr
        </div>
        <div class="mt-2 flex items-center text-sm leading-5 text-gray-600 sm:mr-6">
          <font-awesome-icon class="text-gray-400 mr-2 flex-shrink-0" icon="location" />
          {{event.venue.name}}
        </div>
      </div>
    </div>
    <div class="mt-5 flex lg:mt-0 lg:ml-4">
      <slot />
      <span class="ml-3 shadow-sm rounded-md" v-if="!isDraft">
        <a
          :href="generateEventUrl(event)"
          target="_blank"
          class="inline-flex items-center px-4 py-2 border border-gray-300 text-sm leading-5 font-medium rounded-md text-gray-700 bg-white hover:text-gray-500 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 active:text-gray-800 active:bg-gray-50 active:text-gray-800 transition duration-150 ease-in-out"
        >
          <font-awesome-icon class="-ml-1 mr-2 h-5 w-5" icon="external-link" />Anzeigen
        </a>
      </span>

      <basic-button
        class="sm:ml-3"
        v-if="isDraft"
        @click="publish"
        leading-icon="check"
        :loading="loading"
        :disabled="loading"
      >Veröffentlichen</basic-button>
    </div>
  </div>
</template>

<script>
import EventStatusBadge from "@/components/EventStatusBadge";
import eventClient from "@/api/central/events";
import dayjs from "dayjs";

import InteractsWithEventUrl from "@/mixins/InteractsWithEventUrl";
import InteractsWithEventStatus from "@/mixins/InteractsWithEventStatus";

export default {
  props: ["event"],

  mixins: [InteractsWithEventUrl, InteractsWithEventStatus],

  components: {
    EventStatusBadge
  },
  data() {
    return {
      loading: false
    };
  },
  filters: {
    date(date) {
      return dayjs(date).format("dddd, DD.MM.YYYY HH:mm");
    }
  },
  methods: {
    publish() {
      this.loading = true;

      eventClient
        .publish(this.event.id)
        .then(async () => {
          await this.$store.dispatch("editor/refresh");

          this.$toasted.global.saved();
        })
        .catch(error => {
          this.$toasted.global.error();
        })
        .then(() => (this.loading = false));
    }
  }
};
</script>